import { UnitActivationStatusTone } from '@apps-common/config/unit-activation'
import classNames from 'classnames'
import { getUnitActivationStatusDescription } from '../helpers/getUnitActivationStatusDescription'
import { getUnitActivationStatusIcon } from '../helpers/getUnitActivationStatusIcon'

interface IProps {
  status: string
  className?: string
}

export const UnitActivationStatusPill: React.FC<IProps> = ({ status, className }) => {
  const Icon = getUnitActivationStatusIcon(status)
  const desc = getUnitActivationStatusDescription(status)

  return (
    <div
      className={classNames(
        'flex items-center justify-start gap-[5px] h-[28px]',
        UnitActivationStatusTone[status as keyof typeof UnitActivationStatusTone] || UnitActivationStatusTone.unknown,
        className
      )}
    >
      <Icon className='text-[0.9rem]' />
      <span className={classNames('jost text-[0.85rem] capitalize')}>{desc}</span>
    </div>
  )
}
